module.exports = __webpack_public_path__ + "img/logo-gopay_qris-active.31ebc94b.svg";